import { CartItem } from '../types/CartItem';
import { APP_CONFIG } from '../constants/appConstants';
import {kioskFetch} from './kioskFetch'

const API_BASE = process.env.REACT_APP_IMS_API_BASE_URL || 'http://localhost:4001';
const PRICE_CART_PATH = process.env.REACT_APP_PRICE_CART_PATH || '/api/promos/price-cart';

export type ChannelType = 'POS' | 'KIOSK';

export interface PriceCartItem {
  item_sku: string;
  qty: number;
  unit_price: number;
  category_code?: number;
  line_subtotal: number;
  line_discount: number;
  applied_promos: string[];
}

export interface PriceCartTotals {
  subtotal_before_discount: number;
  total_discount: number;
  subtotal_after_discount: number;
}

export interface PriceCartResponse {
  items: PriceCartItem[];
  totals: PriceCartTotals;
}

export function buildPriceCartItems(cartItems: CartItem[]) {
  return (cartItems || [])
    .map(ci => {
      const sku = (ci.barcode?.trim() || ci.isbn?.trim() || '');
      if (!sku) return null;
      return { item_sku: sku, qty: Math.max(1, ci.quantity || 1) };
    })
    .filter(Boolean) as { item_sku: string; qty: number }[];
}

export async function priceCart(params: {
  locationId?: number;
  channel?: ChannelType;
  cartItems: CartItem[];
  manualPromoCodes?: string[];
}): Promise<PriceCartResponse> {
  const payload = {
    location_id: typeof params.locationId === 'number'
      ? params.locationId
      : (APP_CONFIG.LOCATION_ID ?? 0),
    channel: params.channel ?? 'POS',
    items: buildPriceCartItems(params.cartItems),
    ...(params.manualPromoCodes?.length
      ? { manual_promo_codes: params.manualPromoCodes }
      : {}),
  };

  const res = await kioskFetch(`${API_BASE}${PRICE_CART_PATH}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  const data = await res.json().catch(() => null);

  if (!res.ok) {
    const msg = data?.message || data?.error || `HTTP ${res.status}`;
    throw new Error(msg);
  }

  return data as PriceCartResponse;
}
